import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

export interface MePerfil {
  id: number
  nombre: string
  email: string
  role: string
  avatar?: string | null
  clientePerfil: {
    id: number
    puntos: number
    puntosTotal: number
    estado: 'NUEVO' | 'REGULAR' | 'VIP'
    visitas: number
    mascotas: any[]
  } | null
}

export function useMe() {
  return useQuery<MePerfil>({
    queryKey: ['me'],
    queryFn: () => api.get('/auth/me').then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })
}
